import { asyncStart } from '../../common/index';

export const GET_HB1416_TRACKER = 'hb1416Tracker.getHb1416Tracker';
export const getHb1416Tracker = (snapshotYear) => (dispatch) => {
  dispatch(asyncStart(GET_HB1416_TRACKER));
  dispatch({
    type: GET_HB1416_TRACKER,
    snapshotYear,
  });
};

export const UPDATE_HB1416_TRACKER = 'hb1416Tracker.updateHb1416Tracker';
export const updateHb1416Tracker = (snapshotYear, firebaseId, session = null, fields = null) => (dispatch) => {
  dispatch(asyncStart(UPDATE_HB1416_TRACKER));
  dispatch({
    type: UPDATE_HB1416_TRACKER,
    snapshotYear,
    firebaseId,
    session,
    fields,
  });
};

export const GENERATE_AEP = 'hb1416Tracker.generateAEP';
export const generateAEP = (snapshotYear, firebaseId, language) => (dispatch) => {
  dispatch(asyncStart(GENERATE_AEP));
  dispatch({
    type: GENERATE_AEP,
    snapshotYear,
    firebaseId,
    language,
  });
};

export const GENERATE_ALL_AEPS = 'hb1416Tracker.generateAllAEPs';
export const generateAllAEPs = (snapshotYear, language) => (dispatch) => {
  dispatch(asyncStart(GENERATE_ALL_AEPS));
  dispatch({
    type: GENERATE_ALL_AEPS,
    snapshotYear,
    language,
  });
};

export const MATCH_TIA_DESIGNATIONS = 'hb1416Tracker.matchTiaDesignations';
export const matchTiaDesignations = (snapshotYear) => (dispatch) => {
  dispatch(asyncStart(MATCH_TIA_DESIGNATIONS));
  dispatch({
    type: MATCH_TIA_DESIGNATIONS,
    snapshotYear,
  });
};

export const SELECT_HB1416_STUDENT = 'hb1416Tracker.selectStudent';
export const selectStudent = (firebaseId) => (dispatch) => {
  dispatch({
    type: SELECT_HB1416_STUDENT,
    firebaseId,
  });
};
